import axios from 'axios'
import KeycloakService from '../utils/keycloakService'
import { POST_QUEUE, SEARCH_QUEUE, SEND_OTP } from '../utils/Endpoints'

export const sendSmartQueueOtp = async (number: string) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${SEND_OTP}${number}`,
      '',
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    console.error('Error Sending OTP: ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const submitSmartQueue = async (payload: any, otp: string) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.post(
      `${process.env.REACT_APP_API_GATEWAY_URL}${POST_QUEUE}${otp}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    console.error('Error Submiting SmartQueue : ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}

export const getSmartQueueSearch = async (type: any, search: string) => {
  const token = KeycloakService.getToken()
  try {
    const response: any = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${SEARCH_QUEUE}${type}=${search}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    const { data, success, message } = response?.data || {}
    if (success) {
      return {
        success: true,
        data: data,
        message: message,
      }
    } else {
      return {
        success: false,
        data: null,
        message: message,
      }
    }
  } catch (error: any) {
    console.error('Error Getting SmartQueue Data : ', error)
    return {
      success: false,
      data: null,
      message: error?.message,
    }
  }
}
